import { render, staticRenderFns } from "./AbandonedCarts.vue?vue&type=template&id=7a882ae5&scoped=true&"
import script from "./AbandonedCarts.vue?vue&type=script&lang=js&"
export * from "./AbandonedCarts.vue?vue&type=script&lang=js&"
import style0 from "./AbandonedCarts.vue?vue&type=style&index=0&id=7a882ae5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a882ae5",
  null
  
)

export default component.exports